import { store, getContext, getElement } from '@wordpress/interactivity';
import { CLASSES } from '../constants';

const getHostpotConfig = (hotspotId) => {
  const context = getContext();
  return context.hotspots.find(hotspot => hotspot.id === hotspotId);
};

const getIsInteractive = (hotspotId) => {
  const hotspotConfig = getHostpotConfig(hotspotId);
  return hotspotConfig && hotspotConfig.interactionType !== 'none';
};

const { state, actions } = store("amplify_storytelling_imageMap", {
  state: {
    get isMapAnchorActive() {
      const context = getContext();
      // const isActive = context.activeHotspotId === attributes.id;
      const currentHotspotId = context.hotspotId;

      const isActive = getIsInteractive(currentHotspotId) && context.activeHotspotId === context.hotspotId;
      return isActive;
    },

    get isMapAnchorInactive() {
      return !this.isMapAnchorActive;
    },

    get isMapAnchorInteractive() {
      const context = getContext();
      const currentHotspotId = context.hotspotId;
      return getIsInteractive(currentHotspotId);
    },
  },

  actions: {
    handleHotspotClick: (event) => {
      const hotspotId = event.currentTarget.id;
      const hotspotConfig = getHostpotConfig(hotspotId);

      if (hotspotConfig?.interactionType === 'content') {
        const context = getContext();
        if (context.activeHotspotId === hotspotId) {
          context.activeHotspotId = null; // Deselect if already selected
        } else {
          console.debug(`[amplifyStorytellingImageMap.handleHotspotClick] Activating hotspot: ${hotspotId}`);
          context.activeHotspotId = hotspotId;
        }
      }

      event.stopPropagation(); // Prevent event bubbling
    },

    handleHotspotContentClick: (event) => {
      // Currently we just prevent event propagation to avoid triggering the 
      // background click handler.
      event.stopPropagation(); // Prevent event bubbling
    },

    handleBackgroundClick: (event) => {
      console.debug(`[amplifyStorytellingImageMap.handleBackgroundClick] event:`, event);
      const context = getContext();
      console.debug(`[amplifyStorytellingImageMap.handleBackgroundClick] context:`, context);
      context.activeHotspotId = null; // Deselect any active hotspot
    },
  },

  callbacks: {
    init: () => {
      const context = getContext();
      console.debug(`[amplifyStorytellingImageMap.init] context:`, context);

      const { ref } = getElement();
      console.debug(`[amplifyStorytellingImageMap.init] root element:`, ref);

      // Initialize hotspots
      const hotspots = context.hotspots || [];
      hotspots.forEach(hotspot => {
        // Initialize each hotspot
        const hotspotSvgEl = document.getElementById(hotspot.id);
        const hotspotInteractivityEl = ref.querySelector(`.${CLASSES.HOTSPOT}[data-hotspot-id="${hotspot.id}"]`);

        if (hotspotSvgEl && hotspotInteractivityEl) {
          const interactionType = hotspot.interactionType || 'none';
          const isHotspotInteractive = interactionType !== 'none';

          console.debug(`[amplifyStorytellingImageMap.init] Interaction type for hotspot ${hotspot.id}:`, interactionType);

          // In all cases, remove the existing href and target attributes
          hotspotSvgEl.removeAttribute('href');
          hotspotSvgEl.removeAttribute('target');

          // if (isHotspotInteractive) {
          //   hotspotSvgEl.style.cursor = 'pointer';
          // }

          if (interactionType === 'link' && hotspot.linkUrl) {
            const linkUrl = hotspot.linkUrl || '#';
            hotspotSvgEl.setAttribute('href', linkUrl);
            hotspotSvgEl.setAttribute('target', '_blank');
          }

          if (interactionType === 'content') {
            // hotspotSvgEl.classList.add('hotspot--active');
          }
        }
      });
    },
  },
});
